import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';
import { Calendar } from '@hassanmojab/react-modern-calendar-datepicker';
import { formatDateLabel } from '../../../utils/formatters';
import { calendarLocale } from '../../../constants/calendarLocale';
import * as styles from './datepicker.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Datepicker = function Datepicker(_ref) {
  var checked = _ref.checked,
    onSelectDate = _ref.onSelectDate,
    isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    minDay = _ref.minDay,
    maxDay = _ref.maxDay,
    disabledDays = _ref.disabledDays;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedDate = _React$useState2[0],
    setSelectedDate = _React$useState2[1];

  /*istanbul ignore next*/
  React.useLayoutEffect(function () {
    // @ts-ignore
    import('@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css');
  }, []);
  var selectDate = React.useCallback(function (date) {
    setSelectedDate(date);
    onSelectDate(date);
    setOpen(false);
  }, [setSelectedDate, onSelectDate, setOpen]);
  var open = React.useCallback(function (event) {
    setOpen(true);
    event.stopPropagation();
  }, [setOpen]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    onClick: function onClick(event) {
      event.stopPropagation();
    },
    children: [/*#__PURE__*/_jsx(CheckboxButton, {
      label: formatDateLabel(selectedDate),
      checked: checked,
      onClick: open
    }), isOpen && /*#__PURE__*/_jsx("div", {
      className: styles['wrapper'],
      children: /*#__PURE__*/_jsx(Calendar, {
        value: selectedDate,
        onChange: selectDate,
        shouldHighlightWeekends: true,
        colorPrimary: "#0468FF",
        locale: calendarLocale,
        disabledDays: disabledDays,
        calendarTodayClassName: styles['today'],
        minimumDate: minDay,
        maximumDate: maxDay,
        calendarClassName: styles['small-calendar']
      })
    })]
  });
};